import React from "react";
import { createSubscriptionStore } from "./createSubscriptionStore";
import { Provider } from "react-redux";
import SubscriptionContainer from "./SubscriptionContainer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const SOURCE_LEAVE = "leave";
export const SOURCE_SUBMIT = "submit";
export const SOURCE_SUBMIT_WITHOUT_USER = "submit-without-user";

interface SubscriptionProps {
	isChinaUser: boolean;
	reCaptchaKey: string;
}

export default function Subscription({
	isChinaUser,
	reCaptchaKey,
}: SubscriptionProps) {
	return (
		<Provider store={createSubscriptionStore()}>
			<GoogleReCaptchaProvider
				useRecaptchaNet={isChinaUser}
				reCaptchaKey={reCaptchaKey}
				useEnterprise={true}
			>
				<SubscriptionContainer />
			</GoogleReCaptchaProvider>
		</Provider>
	);
}
